// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ____   ____    .__   __
 * \\   \\ /   /___ |  |_/  |______      ____ ___.__.
 *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |
 *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |
 *    \\___/ \\____/|____/__| (____  /\\___  // ____|
 *                               \\//_____/ \\/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

.react-select-container .react-select__control {
  margin-top: 0.25rem;
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.react-select-container .react-select__control:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 0.5;
}

.react-select-container .react-select__control {
  min-height: 38px;
  height: auto;
}

.dark .react-select-container .react-select__control {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark .react-select-container .react-select__control:focus {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}

.react-select-container .react-select__value-container {
  min-height: 38px;
  height: auto;
  padding-top: 2px;
  padding-bottom: 2px;
}

.react-select-container .react-select__indicators {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100%;
}

.react-select-container .react-select__indicator {
  padding: 0.5rem;
}

.react-select-container .react-select__menu {
  margin-top: 0.25rem;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .react-select-container .react-select__menu {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.react-select-container .react-select__option {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.react-select-container .react-select__option:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.react-select-container .react-select__option {
  height: 38px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease-in-out;
}

.dark .react-select-container .react-select__option {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark .react-select-container .react-select__option:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}

.react-select-container .react-select__option--is-focused {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.dark .react-select-container .react-select__option--is-focused {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}

.react-select-container .react-select__option--is-selected {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark .react-select-container .react-select__option--is-selected {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}

.expandable-option {
  white-space: normal !important;
  word-wrap: break-word !important;
}

.react-select-container .react-select__option.expandable-option:hover {
  position: relative;
  height: auto;
  white-space: normal;
  overflow: visible;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.react-select__menu-list {
  max-height: 300px;
  overflow-y: auto;
}

.react-select-container .react-select__single-value {
  margin-left: 0.5rem;
  max-width: calc(100% - 44px);
  overflow-wrap: break-word;
  font-size: 0.875rem;
  line-height: 1.25rem;
  white-space: normal;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dark .react-select-container .react-select__single-value {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.react-select-container .react-select__input {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.dark .react-select-container .react-select__input {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.react-select-container .react-select__input-container {
  margin: 0px;
  height: 2.25rem;
  padding: 0px;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.dark .react-select-container .react-select__input-container {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.react-select__option-container {
  border-bottom: 1px solid #e2e8f0;
}

.dark .react-select__option-container {
  border-bottom: 1px solid #4a5568;
}

.react-select__option-container:last-child {
  border-bottom: none;
}

.react-select-container .react-select__option.expanded {
  white-space: normal;
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  position: relative;
}

.react-select-dark .react-select__control {
  background-color: #4a5568;
  border-color: #2d3748;
}

.react-select-dark .react-select__menu {
  background-color: #4a5568;
}

.react-select-dark .react-select__option {
  background-color: #4a5568;
  color: white;
}

.react-select-dark .react-select__option--is-focused {
  background-color: #2d3748;
}

.react-select-dark .react-select__option--is-selected {
  background-color: #2b6cb0;
}

.react-select-dark .react-select__multi-value {
  background-color: #2d3748;
}

.react-select-dark .react-select__multi-value__label {
  color: white;
}

.react-select-dark .react-select__multi-value__remove {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/select.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE;;AAGA;EAAA,mBAAqG;EAArG,cAAqG;EAArG,WAAqG;EAArG,uBAAqG;EAArG,iBAAqG;EAArG,sBAAqG;EAArG,4DAAqG;EAArG,0CAAqG;EAArG,uDAAqG;EAArG;AAAqG;;AAArG;EAAA,2GAAqG;EAArG,yGAAqG;EAArG,4FAAqG;EAArG;AAAqG;;AADvG;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAGE;EAAA,sBAA2F;EAA3F,yDAA2F;EAA3F,kBAA2F;EAA3F,yDAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAA3F;EAAA,sBAA2F;EAA3F,2DAA2F;EAA3F,oBAA2F;EAA3F;AAA2F;;AAG7F;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAGE;EAAA,kBAAoC;EAApC,UAAoC;EAApC,QAAoC;EAApC;AAAoC;;AAIpC;EAAA;AAAU;;AAIV;EAAA,mBAAgE;EAAhE,uBAAgE;EAAhE,iBAAgE;EAAhE,sBAAgE;EAAhE,4DAAgE;EAAhE,kBAAgE;EAAhE,4DAAgE;EAAhE,+EAAgE;EAAhE,mGAAgE;EAAhE;AAAgE;;AAIhE;EAAA,sBAAkC;EAAlC,yDAAkC;EAAlC,kBAAkC;EAAlC;AAAkC;;AAIlC;EAAA,kBAAqD;EAArD,mBAAqD;EAArD,mBAAqD;EAArD,oBAAqD;EAArD,oBAAqD;EAArD;AAAqD;;AAArD;EAAA,kBAAqD;EAArD;AAAqD;;AADvD;EAEE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAGE;EAAA,oBAAqC;EAArC;AAAqC;;AAArC;EAAA,kBAAqC;EAArC;AAAqC;;AAIrC;EAAA,kBAAoB;EAApB;AAAoB;;AAIpB;EAAA,kBAAoB;EAApB;AAAoB;;AAIpB;EAAA,kBAA+B;EAA/B,2DAA+B;EAA/B,oBAA+B;EAA/B;AAA+B;;AAI/B;EAAA,kBAAoB;EAApB;AAAoB;;AAGtB;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAGE;EAAA,mBAAuD;EAAvD,4BAAuD;EAAvD,yBAAuD;EAAvD,mBAAuD;EAAvD,oBAAuD;EACvD,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B;AANuD;;AAUvD;EAAA,oBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,mBAA4B;EAA5B,oBAA4B;EAA5B,oBAA4B;EAA5B;AAA4B;;AAI5B;EAAA,oBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,WAAgC;EAAhC,eAAgC;EAAhC,YAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;;AAIhC;EAAA,oBAAiB;EAAjB;AAAiB;;AAGnB;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/*\n * ____   ____    .__   __\n * \\   \\ /   /___ |  |_/  |______      ____ ___.__.\n *  \\   Y   /  _ \\|  |\\   __  \\_ \\   / ___<   |  |\n *   \\     (  <_> )  |_|  |  / __ \\_/ /_/  >___  |\n *    \\___/ \\____/|____/__| (____  /\\___  // ____|\n *                               \\//_____/ \\/\n *\n * Copyright (c) 2017-2025 Voltagy. All rights reserved.\n * https://voltagy.com\n *\n * PROPRIETARY AND CONFIDENTIAL\n *\n * This source code is the proprietary and confidential property of Voltagy.\n * Unauthorized copying, transfer, or use of this file, via any medium, is\n * strictly prohibited without the express written permission of Voltagy.\n *\n * The receipt or possession of this source code and/or related information\n * does not convey or imply any right to use it, reproduce it, disclose its\n * contents, or to manufacture, use, or sell anything that it may describe.\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\"\n * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE\n * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE\n * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE\n * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR\n * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF\n * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS\n * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN\n * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)\n * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE\n * POSSIBILITY OF SUCH DAMAGE.\n *\n */\n\n.react-select-container .react-select__control {\n  @apply mt-1 block w-full rounded-md shadow-sm focus:ring focus:ring-opacity-50 border border-gray-300;\n  min-height: 38px;\n  height: auto;\n}\n\n.dark .react-select-container .react-select__control {\n  @apply bg-gray-700 text-white border-gray-600 focus:border-orange-500 focus:ring-orange-300;\n}\n\n.react-select-container .react-select__value-container {\n  min-height: 38px;\n  height: auto;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.react-select-container .react-select__indicators {\n  @apply absolute right-0 top-0 h-full;\n}\n\n.react-select-container .react-select__indicator {\n  @apply p-2;\n}\n\n.react-select-container .react-select__menu {\n  @apply bg-white border border-gray-300 mt-1 rounded-md shadow-lg;\n}\n\n.dark .react-select-container .react-select__menu {\n  @apply bg-gray-700 border-gray-600;\n}\n\n.react-select-container .react-select__option {\n  @apply text-sm text-gray-900 hover:bg-orange-100 px-4;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: all 0.2s ease-in-out;\n}\n\n.dark .react-select-container .react-select__option {\n  @apply text-white hover:bg-orange-700;\n}\n\n.react-select-container .react-select__option--is-focused {\n  @apply bg-orange-100;\n}\n\n.dark .react-select-container .react-select__option--is-focused {\n  @apply bg-orange-700;\n}\n\n.react-select-container .react-select__option--is-selected {\n  @apply bg-orange-500 text-white;\n}\n\n.dark .react-select-container .react-select__option--is-selected {\n  @apply bg-orange-600;\n}\n\n.expandable-option {\n  white-space: normal !important;\n  word-wrap: break-word !important;\n}\n\n.react-select-container .react-select__option.expandable-option:hover {\n  position: relative;\n  height: auto;\n  white-space: normal;\n  overflow: visible;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.react-select__menu-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.react-select-container .react-select__single-value {\n  @apply text-sm ml-2 break-words max-w-[calc(100%-44px)];\n  white-space: normal;\n  line-height: 1.2;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.dark .react-select-container .react-select__single-value {\n  @apply text-white;\n}\n\n.react-select-container .react-select__input {\n  @apply text-sm text-gray-900;\n}\n\n.dark .react-select-container .react-select__input {\n  @apply text-white;\n}\n\n.react-select-container .react-select__input-container {\n  @apply text-gray-900 m-0 p-0 h-9;\n}\n\n.dark .react-select-container .react-select__input-container {\n  @apply text-white;\n}\n\n.react-select__option-container {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dark .react-select__option-container {\n  border-bottom: 1px solid #4a5568;\n}\n\n.react-select__option-container:last-child {\n  border-bottom: none;\n}\n\n.react-select-container .react-select__option.expanded {\n  white-space: normal;\n  height: auto;\n  max-height: 200px;\n  overflow-y: auto;\n  position: relative;\n}\n\n.react-select-dark .react-select__control {\n  background-color: #4a5568;\n  border-color: #2d3748;\n}\n\n.react-select-dark .react-select__menu {\n  background-color: #4a5568;\n}\n\n.react-select-dark .react-select__option {\n  background-color: #4a5568;\n  color: white;\n}\n\n.react-select-dark .react-select__option--is-focused {\n  background-color: #2d3748;\n}\n\n.react-select-dark .react-select__option--is-selected {\n  background-color: #2b6cb0;\n}\n\n.react-select-dark .react-select__multi-value {\n  background-color: #2d3748;\n}\n\n.react-select-dark .react-select__multi-value__label {\n  color: white;\n}\n\n.react-select-dark .react-select__multi-value__remove {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
